import React from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { FilterProps } from './types';
import { CheckboxFilter } from './checkbox';

/* TODO: replace Select with MultiSelect once it's ready in @ecosystem/newron-design-system */
const { MultiSelect } = inputs;

const MAX_CHECKBOX_ITEMS = 9;

function MultiSelectFilter({ definition, values, disabled, onChange }: FilterProps) {
  const { label: definitionLabel, name, placeholder, options } = definition;
  const value = values?.map(({ value }) => value);
  const label = `${definitionLabel}${value.length ? ` (${value.length})` : ''}`;

  const handleSelectChange = (value: string[]) => {
    const entities = value.map(val => options.find(option => option.value === val));
    onChange(name, entities);
  };

  if (options.length > MAX_CHECKBOX_ITEMS) {
    return (
      <div data-test-id={label}>
        <MultiSelect
          placeholder={placeholder ?? 'Any'}
          label={label}
          options={options}
          values={value}
          disabled={disabled}
          onChange={handleSelectChange}
          combobox
          name={name}
        />
      </div>
    );
  }

  return (
    <div data-test-id={label}>
      <CheckboxFilter label={label} definition={definition} values={values} disabled={disabled} onChange={onChange} />
    </div>
  );
}

export { MultiSelectFilter };
